import { ReactNode, useState} from "react";
import {Button, ButtonProps, message, Modal, Row, Spin, Timeline, Tooltip} from "antd";
import Icon from "@ant-design/icons";
import {useGetThoughtsMutation} from "../../../../../redux/api/langgraph/langgraphApiSlice";
import {useParams} from "react-router-dom";
import {assistantColor} from "./CustomRobotIcon";
import ReactMarkdown from "react-markdown";
import { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

export const MagicIconSvg = () => (
    <svg
        viewBox="0 0 1024 1024"
        width="1em"
        height="1em"
        fill="currentColor"
    >
        <path d="M716.571429 332l167.428571-167.428571-61.142857-61.142857-167.428571 167.428571zm255.428571-167.428571q0 15.428571-10.285714 25.714286l-734.857143 734.857143q-10.285714 10.285714-25.714286 10.285714t-25.714286-10.285714l-113.142857-113.142857q-10.285714-10.285714-10.285714-25.714286t10.285714-25.714286l734.857143-734.857143q10.285714-10.285714 25.714286-10.285714t25.714286 10.285714l113.142857 113.142857q10.285714 10.285714 10.285714 25.714286zm-772-108.571429l56 17.142857-56 17.142857-17.142857 56-17.142857-56-56-17.142857 56-17.142857 17.142857-56zm200 92.571429l112 34.285714-112 34.285714-34.285714 112-34.285714-112-112-34.285714 112-34.285714 34.285714-112zm531.428571 273.142857l56 17.142857-56 17.142857-17.142857 56-17.142857-56-56-17.142857 56-17.142857 17.142857-56zm-365.714286-365.714286l56 17.142857-56 17.142857-17.142857 56-17.142857-56-56-17.142857 56-17.142857 17.142857-56z"/>
    </svg>
)

export const MagicIcon = (props: Partial<CustomIconComponentProps>) => <Icon component={MagicIconSvg} {...props} />

export default function MagicButton(props: ButtonProps & {fieldLabel: ReactNode, fieldValue: string}) {
    const { id: negotiationId } = useParams<{ id: string }>();

    const [fetchThoughts, {isLoading: thoughtsIsLoading}] = useGetThoughtsMutation()

    const [currentThoughts, setCurrentThoughts] = useState<string[]>([])
    const [isModalOpen, setIsModalOpen] = useState<boolean>(false)

    const onOpenModal = async (event: any): Promise<void> => {
        setIsModalOpen(true)
        if (negotiationId) {
            try {
                const thoughts = await fetchThoughts({negotiation_uuid: negotiationId, field: props.fieldValue}).unwrap()
                if (thoughts[props.fieldValue].length) {
                    setCurrentThoughts(thoughts[props.fieldValue])
                }
            } catch (e: any) {
                console.log(e)
                message.error(e.data.detail.message)
            }
        }
    }

    const closeModal = () => {
        setCurrentThoughts([])
        setIsModalOpen(false)
    }


    return <>
        <Tooltip title={"Clicca per vedere i ragionamenti"}>
            <Button
                {...props}
                type={"link"}
                icon={
                    <MagicIcon
                        style={{
                            color: assistantColor,
                            fontSize: '15px',
                        }}
                    />}
                onClick={(e)=> {void onOpenModal(e)}}
            />
        </Tooltip>
        <Modal
            footer={false}
            open={isModalOpen}
            onCancel={() => closeModal()}
            destroyOnClose
            title={<span style={{color: assistantColor}}>{props.fieldLabel} Thoughts</span>}>
            {thoughtsIsLoading && <Row justify={"center"}>
                <Spin/>
            </Row>}
            <Timeline>
                {currentThoughts.map((el, i) => <Timeline.Item key={i} color={assistantColor}><ReactMarkdown>{el}</ReactMarkdown></Timeline.Item>)}
            </Timeline>
        </Modal>
    </>
}
